import axios from 'axios';
import { useCallback, useState } from 'react';

const useAxios = () => {
	const [value, setValue] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);

	const execute = useCallback(async (url, options, callback) => {
		setLoading(true);
		setError(false);
		return await axios({
			method: options?.method || 'GET',
			url,
			headers: {
				'Content-Type': 'application/json',
				...options.headers,
			},
			data: options.data,
		})
			.then((response) => {
				setValue(response?.data);
			})
			.catch((e) => {
				console.error('Axios error: ', e);
				setError(true);
			})
			.finally(() => setLoading(false));
	}, []);

	return {
		execute,
		value,
		status: loading ? 'pending' : error ? 'error' : 'stable',
	};
};

export default useAxios;
